import { BUILDER_LESSON_STATUS } from '@/courses/values/courses.values';
import { BuilderLesson, Parent } from '../models/builder.model';

export function sectionToBuilderLesson(section: any, rootType: string): BuilderLesson {
  let lesson = new BuilderLesson();
  lesson.id = section.id;
  lesson.name = section.name;
  lesson.rootType = rootType;
  lesson.duration = section.lessonDuration;
  lesson.parent = new Parent((section.initialParentId) ? section.initialParentId : section.parentId);
  lesson.fixedOrder = section.fixedSequence;
  lesson.pendingTime = section.lessonDuration;
  lesson.status = BUILDER_LESSON_STATUS.PENDING;
  lesson.fixedSection = 'LESSON';
  lesson.fixedSequence = section.initialFixedSequence ? section.initialFixedSequence :  section.fixedSequence;
  lesson.movedByBuilder = false;
  return lesson;
} 